<template>
    <div>
        <div class="craft">
            <div class="part-one">
                <div class="base-title">
                    <div class="part-one-content">
                        <img
                            class="part-one-title-img"
                            src="../assets/imgs/121/part-1-title.png"
                            alt=""
                        />
                        <div class="part-text part-one-text">
                            新津区技能大师工作室由高技能领军人才依托本区技能含量较高的大中型骨干企事业单位、行业技术研发中心以及重点职业院校（培训学校）为载体领办或创办，工作室设在生产、研发、教学、实训等场所。
                        </div>
                    </div>
                </div>
            </div>
            <div class="part-two">
                <img
                    src="../assets/imgs/121/part-2-title.png"
                    class="part-two-title-img"
                />
                <div
                    class="part-title part-two-title"
                    style="margin-top: 1.44rem"
                >
                    （一）技能大师申报条件
                </div>
                <div class="part-two-items part-text">
                    技能大师应当是某一行业（领域）技能拔尖、技艺精湛并具有较强创新创造能力和社会影响力的高技能人才；遵纪守法，具有良好的工匠精神、职业道德和创新能力；一般应在法定劳动年龄内、身体健康，具有良好的团队精神和奉献精神，具有较强的学习意识和能力，能够承担培养高技能人才的任务，并能起到传授技能和绝技绝活代际传承的作用。同时，应具备以下条件之一：
                    1.在新技术、新工艺、新产品的研发中能发挥重要作用，具有国家技师（二级）及以上职业资格或技能等级，积极开展技术技能革新，取得有一定影响的发明创造，并产生较大的经济效益。
                    2.获得“中华技能大奖”“全国技术能手”“四川省技术能手”“成都市技术能手”和“大国工匠”“天府工匠”“成都工匠”
                    “国务院特殊津贴”“省政府特殊津贴”“成都市政府特殊津贴”“四川杰出创新人才奖”“成都市杰出创新人才奖”等荣誉称号的优秀高技能人才。
                    3.获得市级及以上工艺美术大师、非物质文化遗产传承人称号，掌握民间传统技能、绝招绝技，长期从事技能传承工作，并在行业领域具有一定影响力的技艺人才。
                </div>
                <div
                    class="part-title part-two-title"
                    style="margin-top: 0.35rem; line-height: 0.5rem"
                >
                    （二）依托单位建立工作室，单位应具备以下条件
                </div>
                <div class="part-two-items part-text">
                    1.高度重视技能人才队伍建设工作，建立了较为完善的技能人才培养、评价、选拔、使用和激励制度，制定了一系列加快高技能人才队伍建设的措施办法，并认真组织实施。
                    <br />
                    2.能够并承诺为技能大师工作室提供相应的资金支持以及场地、设备等必要的工作条件。
                </div>
            </div>
            <div class="part-three">
                <img
                    src="../assets/imgs/121/part-3-title.png"
                    class="part-two-title-img"
                />
                <div class="part-three-items part-text">
                    （一）对确定的区级技能大师工作室，按每个5万元的标准给予一次性补贴，支持工作室设备设施的更新完善，论文、著作的出版，开展培训和技术交流活动等。
                </div>
                <div class="part-three-items part-text">
                    （二）申报市级及以上技能大师工作室的，原则上优先从区级技能大师工作室中推荐。
                </div>
            </div>
            <div class="part-two">
                <img
                    src="../assets/imgs/121/part-4-title.png"
                    class="part-two-title-img"
                />
                <div
                    style="
                        margin-top: 1.44rem;
                        font-size: 0.3rem;
                        font-weight: 500;
                        color: #333333;
                        line-height: 0.44rem;
                        text-align: left;
                    "
                >
                    技能大师工作室申报需提交以下资料：
                </div>
                <div class="part-two-content" style="margin-top: 0.23rem">
                    <div style="margin-bottom: 0.22rem; position: relative">
                        <div class="part-two-dot">1</div>
                        《成都市新津区技能大师工作室申报表》
                    </div>
                    <div style="margin-bottom: 0.22rem; position: relative">
                        <div class="part-two-dot">2</div>
                        申请报告。
                        <div>
                            1.申办工作室名称（格式统一为“新津+领办、创办人名字+职业工种名称+技能大师工作室”）；<br/>
                            2.工作室所依托的单位情况；<br/>
                            3.工作室成立的条件、现有优势及前景作用；<br/>
                            4.技能大师详介、工作室主要成员简介；<br/>
                            5.依托单位对工作室的支持措施；<br/>
                            6.工作室计划目标等。
                        </div>
                    </div>
                    <div style="margin-bottom: 0.22rem; position: relative">
                        <div class="part-two-dot">3</div>
                        技能大师和工作室主要成员身份证复印件及其他证明材料复印件（如获奖证书、职业资格证书等）。
                    </div>
                </div>
            </div>
            <div class="part-four">
                <img
                    src="../assets/imgs/121/part-5-title.png"
                    class="part-two-title-img"
                />
                <div class="main-content">
                    <div
                        class="part-four-items"
                    >
                        <div class="title-bg">印发申报通知</div>


                    </div>
                    <div
                        class="part-four-items"
                    >
                        <div class="title-bg title-bg2">项目申报</div>
                        <div class="part-four-content1">
                            符合申报资格和条件的单位，向区人社局提交申报材料
                        </div>
                    </div>
                    <div
                        class="part-four-items"
                    >
                        <div class="title-bg title-bg3">材料初审</div>
                        <div class="part-four-content1">
                            区人社局相关科室对申报单位资格和条件进行审核
                        </div>
                    </div>
                    <div
                        class="part-four-items"
                    >
                        <div class="title-bg title-bg4">综合评议</div>
                        <div class="part-four-content1">
                            区人社局在对申报材料的完整性、规范性进行审核后，组织专家开展综合评审，议定拟评选名单
                        </div>
                    </div>
                    <div
                        class="part-four-items"
                    >
                        <div class="title-bg title-bg5">项目公示</div>
                        <div class="part-four-content1">
                            区人社局党组研究确定拟评选名单，面向社会公示5个工作日
                        </div>
                    </div>
                    <div
                        class="part-four-items"
                        style="border:none"
                    >
                        <div class="title-bg title-bg6">确定项目</div>
                        <div class="part-four-content1">
                            由区委人才工作领导小组办公室和区人社局联合发文正式命名
                        </div>
                    </div>
                </div>
            </div>
            <div class="contact">
                <img
                    class="top"
                    src="./../assets/imgs/label/contact6.png"
                    alt=""
                />
                <div class="content">
                    <div class="number">
                        <span class="label">政策咨询电话：</span>

                        <div><a href="tel:028-82593434">028-82593434</a></div>
                    </div>
                    <div class="unit">
                        <span class="label">责任单位：</span>
                        新津区人社局
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import bottom from "../components/bottom.vue";
// import call from "../components/call.vue";

export default {
    name: "",
    data() {
        return {};
    },
    components: {
        // bottom,
        // call,
    },
    created() {},
    mounted() {},
    computed: {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.craft {
    background: #0839b7;
    overflow: hidden;
    padding: 0.24rem 0.12rem;
    padding-bottom: 1.65rem;
    box-sizing: border-box;
    width: 100vw;
    height: 100vh;
    overflow-y: auto;

    .part-title {
        font-size: 0.34rem;
        // //font-family:: PingFang SC-Bold, PingFang SC;
        font-weight: bold;
        color: #333333;
        position: relative;

        &::before {
            position: absolute;
            content: "";
            width: 0.28rem;
            height: 0.28rem;
            border-radius: 50%;
            background: none;
            border: 0.06rem solid #ff6d60;
            box-sizing: border-box;
            top: 0.08rem;
            left: -0.2rem;
        }
    }

    .part-text {
        font-size: 0.26rem;
        // //font-family:: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #4e4e4e;
        line-height: 0.44rem;
        text-align: left;
    }

    .part-one {
        height: 7.5rem;
        width: 7.5rem;
        margin: 0 auto;

        .base-title {
            width: 7.26rem;
            height: 4.73rem;
            background: url(../assets/imgs/121/base-title.png);
            background-size: 100% 100%;
            position: relative;

            .part-one-content {
                width: 6.85rem;
                background: #ffffff;
                border-radius: 10px;
                position: absolute;
                top: 4.02rem;
                left: 0.22rem;
                padding-left: 0.36rem;
                padding-right: 0.37rem;
                box-sizing: border-box;
                padding-bottom: 0.35rem;

                .part-one-title-img {
                    position: absolute;
                    top: -0.32rem;
                    left: -0.18rem;
                    width: 7.03em;
                    height: 1.37rem;
                }

                .part-one-text {
                    margin-top: 1.2rem;
                }
            }
        }
    }

    .part-two-title-img {
        width: 7.03rem;
        height: 1.37rem;
        top: 0;
        left: -0.2rem;
        position: absolute;
    }

    .part-two {
        margin-left: 0.02rem;
        width: 6.85rem;
        margin-top: 0.22rem;
        background: #e8eeff;
        border-radius: 0.16rem;
        padding-left: 0.25rem;
        padding-right: 0.3rem;
        box-sizing: border-box;
        margin: 0 auto;
        margin-top: 0.22rem;
        border: 0.00001px solid transparent;
        position: relative;

        .part-two-title {
            text-align: left;
            margin-left: 0.33rem;
            margin-bottom: 0.22rem;

            &::before {
                position: absolute;
                content: "";
                width: 0.28rem;
                height: 0.28rem;
                border-radius: 50%;
                background: none;
                border: 0.06rem solid #ff6d60;
                box-sizing: border-box;
                top: 0.08rem;
                left: -0.35rem;
            }
        }

        .part-two-items {
            width: 6.35rem;
            padding-bottom: 0.35rem;
            background: #ffffff;
            border-radius: 10px;
            padding: 0.31rem;
            box-sizing: border-box;
            position: relative;
            margin-bottom: 0.22rem;
        }
        .part-two-content {
            margin-top: 0.2rem;
            margin-bottom: 0.3rem;
            width: 6.22rem;
            background: #ffffff;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 0.34rem 0.24rem 0.15rem 0.67rem;
            font-size: 0.26rem;
            // //font-family:: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #4e4e4e;
            line-height: 0.44rem;
            text-align: left;

            .part-two-dot {
                position: absolute;
                top: 0;
                left: -0.46rem;
                width: 0.36rem;
                height: 0.36rem;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                color: #fff;
                font-size: 0.21rem;
                background: #739bfe;
                border-radius: 50%;
            }
        }
    }

    .part-three {
        width: 6.85rem;
        background: #e8eeff;
        border-radius: 0.22rem;

        margin-left: 0.02rem;
        margin-top: 0.22rem;
        box-sizing: border-box;
        margin: 0 auto;
        margin-top: 0.22rem;
        border: 0.00001px solid transparent;
        position: relative;
        padding: 1.5rem 0.25rem 0.35rem 0.25rem;

        .part-three-items {
            width: 6.35rem;
            padding-bottom: 0.35rem;
            background: #ffffff;
            border-radius: 10px;
            padding: 0.31rem;
            box-sizing: border-box;
            position: relative;
            margin-bottom: 0.22rem;
        }
    }

    .part-four {
        width: 6.85rem;
        background: #e8eeff;
        border-radius: 10px;
        margin-left: 0.02rem;
        margin-top: 0.22rem;
        box-sizing: border-box;
        margin: 0 auto;
        margin-top: 0.22rem;
        border: 0.00001px solid transparent;
        position: relative;
        padding: 1.2rem 0.25rem 0.35rem 0.25rem;

        .main-content {
            margin-top: 0.34rem;
            width: 6.35rem;
            background: #ffffff;
            border-radius: 10px;
            box-sizing: border-box;
            padding-top: 0.9rem;
            padding-left: 0.35rem;
            padding-right: 0.31rem;

            .part-four-items {
                box-sizing: border-box;
                border-left: 0.02rem dashed #739bfe;
                margin-bottom: 0.6rem;
                padding-left: 0.33rem;
                padding-top: 0.2rem;
                position: relative;
                font-size: 0.26rem;
                // //font-family:: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #4e4e4e;
                line-height: 0.44rem;
                text-align: left;
                padding-bottom: 0.35rem;

                .title-bg {
                    position: absolute;
                    width: 3.31rem;
                    height: 0.6rem;
                    top: -0.6rem;
                    left: -0.25rem;
                    display: inline-flex;
                    align-items: center;
                    font-size: 0.34rem;
                    // //font-family:: PingFang SC-Bold, PingFang SC;
                    font-weight: bold;
                    color: #3d5aa3;
                    padding-left: 0.58rem;
                    background: url(../assets/imgs/craft/part4-1.png);
                    background-size: 100% 100%;
                }

                .title-bg2 {
                    background: url(../assets/imgs/craft/part4-2.png);
                    background-size: 100% 100%;
                }

                .title-bg3 {
                    width: 5rem;
                    height: 0.6rem;
                    background: url(../assets/imgs/Relocationallowance/part4-3.png);
                    background-size: 100% 100%;
                }

                .title-bg4 {
                    background: url(../assets/imgs/craft/part4-4.png);
                    background-size: 100% 100%;
                }
                .title-bg5 {
                    background: url(../assets/imgs/121/part5.png);
                    background-size: 100% 100%;
                }
                .title-bg6 {
                    background: url(../assets/imgs/121/part6.png);
                    background-size: 100% 100%;
                }

                .inside-title {
                    font-weight: 800;
                }

                .part-four-content2 {
                    font-weight: bolder;
                }
            }
        }
    }

    .part-five {
        width: 6.85rem;
        height: 1.17rem;
        background: #fff;
        margin-top: 0.32rem;
        border-radius: 10px;
        box-sizing: border-box;
        padding: 0.25rem;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 0.34rem;
        // //font-family:: PingFang SC-Heavy, PingFang SC;
        font-weight: 800;
        color: #2350bf;
    }

    .bottom-info {
        margin-top: 0.22rem;
        font-size: 0.24rem;
        // //font-family:: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #97a9d9;

        a {
            text-decoration: none;
            // color: #97a9d9;
        }
    }
}
</style>
